import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/pengkajian-restrain", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/pengkajian-restrain/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/pengkajian-restrain`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/pengkajian-restrain/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http.putData(`/pengkajian-restrain/${id}/sign-dokter`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPerawat(id: number, data) {
  const response = await http.putData(`/pengkajian-restrain/${id}/sign-perawat`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/pengkajian-restrain/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

async function storeMonitoring(pengkajianId: number, data) {
  const response = await http.postData(`/pengkajian-restrain/${pengkajianId}/monitoring`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateMonitoring(monitoringId: number, data) {
  const response = await http.putData(`/pengkajian-restrain-monitoring/${monitoringId}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function deleteMonitoring(monitoringId: number) {
  const response = await http.deleteData(`/pengkajian-restrain-monitoring/${monitoringId}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/pengkajian-restrain/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDokter,
  signPerawat,
  destroy,
  storeMonitoring,
  updateMonitoring,
  deleteMonitoring,
  print
};
